module.exports = "/contribution/resources/c871fd94a9d7a228344bfb2b5a0d7a8b.gif";